export const moonScalingBreakpoints = [
  { width: 540, scale: 1.41 },
  { width: 768, scale: 0.75 },
  { width: 1024, scale: 0.7 },
  { width: 1280, scale: 0.75 },
  { width: 1440, scale: 0.8 },
  { width: 1600, scale: 0.85 },
  { width: 1700, scale: 0.9 },
  { width: 1800, scale: 0.95 },
  { width: Infinity, scale: 1.0 },
];

export const moonTranslateXMap = {
  1.41: '35.5%',
  1.0: '3.5%',
  0.95: '4%',
  0.9: '5%',
  0.85: '7%',
  0.8: '15%',
  0.75: '18%',
  0.7: '25%',
};

export const mountainVerticalOffsetBreakpoints = [
  { width: 414, offset: '44vh' },
  { width: 450, offset: '44vh' },
  { width: 500, offset: '45vh' },
  { width: 550, offset: '46vh' },
  { width: 600, offset: '48vh' },
  { width: 664, offset: '50vh' },
  { width: Infinity, offset: '6vh' },
];

export const craterVerticalOffsetBreakpoints = [
  { width: 414, offset: '62vh' },
  { width: 450, offset: '62vh' },
  { width: 500, offset: '63vh' },
  { width: 530, offset: '64vh' },
  { width: 560, offset: '69vh' },
  { width: 580, offset: '72vh' },
  { width: 600, offset: '73vh' },
  { width: 620, offset: '73vh' },
  { width: 664, offset: '75vh' },
  { width: Infinity, offset: '8vh' },
];
